/* wf-cart.js — Shared cart drawer logic */
(function() {
  'use strict';

  const drawer    = document.getElementById('wf-cart-drawer');
  const overlay   = document.getElementById('wf-cart-overlay');
  const closeBtn  = document.getElementById('wf-cart-close');
  const trigger   = document.getElementById('wf-cart-trigger');
  const cartItems = document.getElementById('wf-cart-items');
  const cartEmpty = document.getElementById('wf-cart-empty');
  const cartFooter= document.getElementById('wf-cart-footer');
  const subtotalEl= document.getElementById('wf-cart-subtotal');
  const countEl   = document.getElementById('wf-cart-count');
  const waBanner  = document.getElementById('wf-cart-wa-trigger');
  const waBtn     = document.getElementById('wf-cart-wa-btn');

  const WA_NUMBER    = window.WF && window.WF.waNumber || '';
  const WA_THRESHOLD = window.WF && window.WF.waThreshold || 50000;

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2 });
  }

  function escHtml(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── Open / Close ──
  function open() {
    if (!drawer) return;
    drawer.classList.add('wf-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wf-no-scroll');
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('wf-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wf-no-scroll');
  }

  trigger  && trigger.addEventListener('click', () => { open(); refresh(); });
  closeBtn && closeBtn.addEventListener('click', close);
  overlay  && overlay.addEventListener('click', close);

  // ── Refresh cart ──
  async function refresh() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      renderCart(data);
    } catch(e) {}
  }

  function renderCart(data) {
    const items = data.items || [];

    if (countEl) countEl.textContent = data.item_count || 0;

    if (!items.length) {
      if (cartEmpty)  cartEmpty.style.display  = 'block';
      if (cartItems)  cartItems.style.display  = 'none';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    if (cartEmpty)  cartEmpty.style.display  = 'none';
    if (cartItems)  cartItems.style.display  = 'block';
    if (cartFooter) cartFooter.style.display = 'block';

    cartItems.innerHTML = items.map(item => `
      <div class="wf-cart-item" data-key="${item.key}">
        ${item.image
          ? `<img src="${item.image}" alt="${escHtml(item.title)}" class="wf-cart-item__img" width="64" height="64">`
          : `<div class="wf-cart-item__img wf-cart-item__img--placeholder"></div>`}
        <div class="wf-cart-item__info">
          <span class="wf-cart-item__title">${escHtml(item.product_title)}</span>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<span class="wf-cart-item__variant">${escHtml(item.variant_title)}</span>` : ''}
          ${renderProperties(item.properties)}
          <div class="wf-cart-item__row">
            <div class="wf-cart-item__qty-ctrl">
              <button class="wf-cart-qty-btn" data-key="${item.key}" data-delta="-1">−</button>
              <span>${item.quantity}</span>
              <button class="wf-cart-qty-btn" data-key="${item.key}" data-delta="1">+</button>
            </div>
            <span class="wf-cart-item__price">${formatMoney(item.line_price)}</span>
          </div>
        </div>
        <button class="wf-cart-item__remove" data-key="${item.key}" aria-label="Eliminar">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
        </button>
      </div>`).join('');

    // Subtotal
    if (subtotalEl) subtotalEl.textContent = formatMoney(data.total_price);

    // WhatsApp threshold
    const totalMXN = data.total_price / 100;
    if (waBanner) waBanner.style.display = totalMXN >= WA_THRESHOLD ? 'block' : 'none';
  }

  function renderProperties(props) {
    if (!props || !Object.keys(props).length) return '';
    return '<div class="wf-cart-item__props">' +
      Object.entries(props).map(([k,v]) =>
        `<span>${escHtml(k)}: ${escHtml(v)}</span>`).join('') +
      '</div>';
  }

  // ── Cart interactions ──
  cartItems && cartItems.addEventListener('click', async e => {
    const removeBtn = e.target.closest('.wf-cart-item__remove');
    const qtyBtn    = e.target.closest('.wf-cart-qty-btn');

    if (removeBtn) {
      await updateItem(removeBtn.dataset.key, 0);
    } else if (qtyBtn) {
      const item  = qtyBtn.closest('.wf-cart-item');
      const qtyEl = item.querySelector('.wf-cart-item__qty-ctrl span');
      const cur   = parseInt(qtyEl ? qtyEl.textContent : 1);
      const delta = parseInt(qtyBtn.dataset.delta);
      await updateItem(qtyBtn.dataset.key, Math.max(0, cur + delta));
    }
  });

  async function updateItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      refresh();
    } catch(e) {}
  }

  // ── WhatsApp ──
  waBtn && waBtn.addEventListener('click', async () => {
    const res  = await fetch('/cart.js');
    const data = await res.json();
    let msg    = '¡Hola! Tengo más de $50,000 MXN para invertir en mi proyecto. Mi carrito actual:\n\n';
    (data.items || []).forEach(item => {
      msg += `• ${item.product_title} (${item.variant_title !== 'Default Title' ? item.variant_title : ''}): ${item.quantity} pzas — ${formatMoney(item.line_price)}\n`;
    });
    msg += `\nTotal: ${formatMoney(data.total_price)}`;
    const dest = WA_NUMBER.replace(/\D/g, '');
    const a    = document.createElement('a');
    a.href     = `https://wa.me/${dest}?text=${encodeURIComponent(msg)}`;
    a.target   = '_blank';
    a.rel      = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });

  // ── Package ATC buttons (on packages section) ──
  document.addEventListener('click', async e => {
    const pkgBtn = e.target.closest('.wf-pkg-atc');
    const waBtn2 = e.target.closest('.wf-pkg-atc-wa');

    if (pkgBtn) {
      const variantId = pkgBtn.dataset.variantId;
      if (!variantId) return;
      pkgBtn.disabled = true;
      pkgBtn.textContent = 'Agregando...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
        });
        if (res.ok) {
          open(); refresh();
          pkgBtn.textContent = '¡Agregado ✓';
          setTimeout(() => {
            pkgBtn.textContent = pkgBtn.dataset.originalText || 'Agregar al carrito';
            pkgBtn.disabled = false;
          }, 2500);
        } else {
          pkgBtn.textContent = 'Error';
          pkgBtn.disabled = false;
        }
      } catch(err) {
        pkgBtn.textContent = 'Error';
        pkgBtn.disabled = false;
      }
    }

    if (waBtn2) {
      const msg  = waBtn2.dataset.msg || '';
      const dest = WA_NUMBER.replace(/\D/g, '');
      const a    = document.createElement('a');
      a.href     = `https://wa.me/${dest}?text=${msg}`;
      a.target   = '_blank';
      a.rel      = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  });

  // ── Expose globally ──
  window.WFCart = { open, close, refresh };

})();
